import React from "react";
import PropTypes from "prop-types";
import "./Grid.css";

const Grid = ({ rows = 0, cols = 0, data = [], headers = [], style }) => {
  let thead = null;

  if (headers.length > 0) {
    thead = (
      <thead>
        <tr>{headers.map(header => <th key={header}>{header}</th>)}</tr>
      </thead>
    );
  }

  return (
    <table className="bordered" style={style}>
      {thead}
      <tbody>
        {[...Array(rows)].map((_, r) => (
          <tr key={r}>
            {[...Array(cols)].map((_, c) => {
              const cell = data[r * cols + c];
              if (React.isValidElement(cell)) {
                return <td key={`${r}x${c}`}>{cell}</td>;
              }
              return (
                <td className="text" key={`${r}x${c}`}>
                  {cell}
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

Grid.propTypes = {
  rows: PropTypes.number,
  cols: PropTypes.number,
  data: PropTypes.array,
};

export default Grid;



// WEBPACK FOOTER //
// ./src/components/Calendar/Grid.js